export default "__VITE_ASSET__85a55G0Q__"